import { FC, ReactNode } from 'react';

import { clsx } from 'clsx';

import cls from './SectionTitle.module.scss';

type SectionTitleProps = {
  children: ReactNode;
  className?: string;
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  onClick?: () => void;
};

export const SectionTitle: FC<SectionTitleProps> = ({ className, children, tag: Tag = 'h2', onClick }) => {
  return (
    <Tag
      className={clsx(cls.sectionTitle, className, { [cls.clickable]: !!onClick })}
      onClick={onClick}
    >
      {children}
    </Tag>
  );
};
